import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { apiProvider } from './utils/provider'

const url = 'v1/files'
const plural = 'files'
const single = 'file'

const files = new ApiCore({
	index: false,
    findOne: true,
    findAll: false,
	create: false,
	update: false,
    remove: false,
    upload: true,
	url: url,
	plural: plural,
	single: single
})

files.findOne = (id, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`, options)
}

export default files
